<template>
  <component :is="wrapperTag" :class="wrapperClass" ref="rootEl">
    <slot v-if="visible" />
  </component>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  once: { type: Boolean, default: true },
  rootMargin: { type: String, default: '0px 0px 300px 0px' },
  threshold: { type: [Number, Array], default: 0 },
  wrapperTag: { type: String, default: 'div' },
  wrapperClass: { type: String, default: 'contents' },
});

const visible = ref(false);
const rootEl = ref(null);
let observer = null;

onMounted(() => {
  if (typeof window === 'undefined' || !rootEl.value) {
    visible.value = true;
    return;
  }
  if (!('IntersectionObserver' in window)) {
    visible.value = true;
    return;
  }
  observer = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          visible.value = true;
          if (props.once && observer) {
            observer.disconnect();
            observer = null;
          }
          break;
        }
      }
    },
    { root: null, rootMargin: props.rootMargin, threshold: props.threshold }
  );
  observer.observe(rootEl.value);
});

onBeforeUnmount(() => {
  if (observer) observer.disconnect();
});
</script>
